var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 3.82812H12.0312C11.5961 3.82812 11.1788 4.00098 10.8712 4.30865C10.5635 4.61633 10.3906 5.03363 10.3906 5.46875V10.3906H5.46875C5.03363 10.3906 4.61633 10.5635 4.30865 10.8712C4.00098 11.1788 3.82812 11.5961 3.82812 12.0312V29.5312C3.82812 29.9664 4.00098 30.3837 4.30865 30.6913C4.61633 30.999 5.03363 31.1719 5.46875 31.1719H22.9688C23.4039 31.1719 23.8212 30.999 24.1288 30.6913C24.4365 30.3837 24.6094 29.9664 24.6094 29.5312V24.6094H29.5312C29.9664 24.6094 30.3837 24.4365 30.6913 24.1288C30.999 23.8212 31.1719 23.4039 31.1719 22.9688V5.46875C31.1719 5.03363 30.999 4.61633 30.6913 4.30865C30.3837 4.00098 29.9664 3.82812 29.5312 3.82812ZM21.3281 27.8906H7.10938V13.6719H21.3281V27.8906ZM27.8906 21.3281H24.6094V12.0312C24.6094 11.5961 24.4365 11.1788 24.1288 10.8712C23.8212 10.5635 23.4039 10.3906 22.9688 10.3906H13.6719V7.10938H27.8906V21.3281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0524f4d73ab0e6cbc2a92e405ce0278e.svg";
export { ForwardRef as ReactComponent };